<template>
    <div :class="[{'double-new-style': doubleNew}]">
        <CommonTitle
            :title="modelTitle"
            :showMore="true"
            @goMore="goSquare"
            :tag-list="tagList"
            @changeTag="onChangeTag"
        />
        <ul class="online-courses" v-if="list.length" v-loading="loading">
            <li
                class="online-courses-item"
                v-for="item in list"
                :key="item.id"
                @click="toDetail(item.id)"
            >
                <div class="list-item link" v-link="linkUrl(item.id)">
                    <div class="list-item-img">
                        <LazyImage :src="item.cover" className="img" />
                        <div class="hour-tag" v-if="doubleNew">
                            学时：{{ item.classHour || 0 }}
                        </div>
                    </div>
                    <div class="list-item-content">
                        <div class="title">
                            <Ellipsis :rows="2" :content="item.title" />
                        </div>
                        <div class="hour" v-if="!doubleNew">
                            学时：{{ item.classHour || 0 }}
                        </div>
                        <div
                            :class="[
                                'create-user',
                                'overflow-ellipsis',
                                {isHide: !getTeacherName(item)}
                            ]"
                            :title="`发布人：${getTeacherName(item)}`"
                        >
                            发布人：{{ getTeacherName(item) }}
                        </div>
                        <template v-if="doubleNew">
                            <div
                                :class="[
                                    'hour',
                                    'overflow-ellipsis',
                                    {isHide: !getSchoolName(item)}
                                ]"
                                :title="`学校：${getSchoolName(item)}`"
                            >
                                学校：{{ getSchoolName(item) }}
                            </div>
                        </template>
                    </div>
                </div>
            </li>
        </ul>
        <BigNoData
            v-else
            class="no-data"
            url="no-lesson.png"
            :info="`暂无${modelTitle || '网络课程'}`"
        />
    </div>
</template>
<script setup>
import Ellipsis from '@/components/ellipsis.vue';
import CommonTitle from '@/components/home-common-title/index.vue';
import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import {ref, onMounted} from 'vue';
import {useStore} from 'vuex';
import {pageJump} from '@/global/location-transfer';
import {jumpHref} from '@/router/jumpHref.js';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    },
    tagList: {
        type: Array,
        default: () => {
            return [];
        }
    },
    doubleNew: {
        type: Boolean,
        default: false
    }
});

const store = useStore();

let total = ref(0);
const list = ref([]);

const loading = ref(false);
let filterData = ref({
    pageIndex: 1,
    pageSize: 4,
    showCourseData: 1,
    bizScene: 'mooc',
    orderType: 'hot', // 排序方式 new-最新 hot-最热 audit-审核状态 recommend-推荐值 keyword-关键字
    queryScope: 'dtBrand',
    stageSubjectIds: []
});

function getList() {
    loading.value = true;
    G_transmit('getFrontMoocList', {
        name: 'getFrontMoocList',
        data: {
            ...filterData.value
        },
        message: false
    })
        .then(({data, status: {code, message}}) => {
            if (code === 200) {
                list.value = (data && data.rows) || [];
                total.value = data.total;
            }
            loading.value = false;
        })
        .catch(err => {
            console.log('error', err);
            loading.value = false;
        });
}

// 跳转慕课详情
function toDetail(id) {
    pageJump(jumpHref.mooc.detail(id), true);
}

// 跳转广场
function goSquare () {
    pageJump({name: 'moocSquare'});
}

function linkUrl(id) {
    return {
        url: jumpHref.mooc.detail(id),
        className: 'link-item'
    };
}

const getTeacherName = data => {
    return data.lecturerList && data.lecturerList.length
        ? data.lecturerList[0].name
        : '';
};

const getSchoolName = data => {
    return data.lecturerList && data.lecturerList.length
        ? data.lecturerList[0].workPlace
        : '';
};

const onChangeTag = tag => {
    filterData.value.stageSubjectIds = tag;
    getList();
};

onMounted(() => {
    let tag = props.doubleNew ? [1204] : [];
    onChangeTag(tag);
});
</script>

<style lang="scss" scoped>
.online-courses {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    border-radius: 4px;
}

.online-courses-item {
    box-sizing: border-box;
    width: 277px;
    margin-top: 30px;
    margin-right: 30px;
    cursor: pointer;

    &:hover {
        box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.15);
        .title {
            color: var(--home-main-color) !important;
        }
        .list-item-content {
            border-color: transparent;
        }
    }

    &:nth-child(n + 4) {
        margin-right: 0;
    }

    .list-item-img {
        width: 100%;
        height: 156px;
        position: relative;
        .img {
            width: 100%;
            height: 100%;
            border-radius: 4px 4px 0px 0px;
        }
    }

    .list-item-content {
        box-sizing: border-box;
        position: relative;
        padding: 12px 20px 20px;
        width: 100%;
        border-radius: 0px 0px 4px 4px;
        border-left: 1px solid #e4e9ee;
        border-right: 1px solid #e4e9ee;
        border-bottom: 1px solid #e4e9ee;
        .title {
            height: 48px;
            font-size: 16px;
            font-weight: bold;
            color: #000000;
            line-height: 24px;
            word-break: break-all;
        }
        .hour {
            font-size: 14px;
            color: #000000;
            line-height: 14px;
            margin-top: 12px;
        }
        .create-user {
            font-size: 14px;
            color: #666666;
            line-height: 14px;
            margin-top: 12px;
        }
    }
}

.no-data {
    margin-top: 50px;
}

.double-new-style {
    .list-item-content {
        padding: 15px 20px 20px;
        .title {
            height: 54px;
            line-height: 27px;
            font-size: 18px;
        }
        .hour {
            color: #666666;
            margin-top: 15px;
        }
        .create-user {
            margin-top: 15px;
        }
    }
    .list-item-img {
        .hour-tag {
            position: absolute;
            bottom: 10px;
            right: 10px;
            border-radius: 4px;
            padding: 4px 6px;
            background: rgba(0, 0, 0, 0.5);
            font-size: 12px;
            color: #ffffff;
            line-height: 14px;
        }
    }
}
.isHide {
    visibility: hidden;
}
</style>
